<template>
  <material-card
    :title="title || config.title"
    :text="subtitle"
    color="primary"
    class="elevation-1">

    <v-dialog v-model="openAuditTrail" max-width="1400px" v-if="!hideAudit">
      <app-audit-trail-timeline :entity="entityName" v-if='openAuditTrail' :entity_id="auditTrailEntityId" :fields='config.fields' :hide-fields="{ [entityName]: config.hideAuditFields }"/>
    </v-dialog>

    <!-- embedded upsert dialog -->
    <v-dialog
      v-if="!hideUpsert && $can('read', entityName) && config.upsert !== 'full' && openUpsert"
      v-model="openUpsert"
      :max-width="upsertMaxWidth">
      <slot name="upsert">
        <app-upsert
          v-if="openUpsert"
          :title="upsertTitle || config.title || title || entityName"
          :item="item || hiddenFields"
          :config="config"
          :subtitle="subtitle"
          :apiUpsert="apiUpsert"
          :apiGetdetail="apiGetdetail"
          modal
          @saved="upsertSaved"
          :readonly="!upsertIsCreate && (readonly || !$can('upsert', entityName))"
          @close="openUpsert=false" />
      </slot>

    </v-dialog>
    <template slot='headerActions'>
      <slot name='headerActions'/>
      <v-btn
        id="plus_btn"
        v-if="!hideUpsert && !hideCreate && $can('upsert', entityName)"
        color="pink"
        @click="upsertAction()">
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </template>

    <!-- embedded inline upsert, should use Upsert  -->
    <v-form
      class='mt-2'
      v-if="inlineUpsert"
      ref="form"
      v-model="validForm">
      <v-container grid-list-md style="max-width:1450px">
        <v-layout wrap>
          <core-field
            v-for="field in fields"
            :readonly="readonly || (typeof field.readonly === 'function' ? field.readonly(item, $store.state) : field.readonly)"
            :key="field.value"
            :field="field"
            :item="item"
            v-model="item[field.value]" />
        </v-layout>
        <v-btn
          :disabled="!validForm"
          class="mx-1 font-weight-light"
          color="success"
          small
          @click="save">Save</v-btn>
      </v-container>
    </v-form>
    <v-data-table
      :items="items"
      :headers-length="headers.length"
      :loading="loading"
      :hide-default-footer="totalItems<=pagination.itemsPerPage"
      :options.sync='pagination'
      @update:items-per-page="getData"
      @update:page='getData'
      :server-items-length="totalItems"
    >

      <template
        slot="header">
        <thead class='v-data-table-header'>
        <tr>
          <th
            v-for="header in headers"
            :key="header.value"
            :class="[
              'column',
              header.table.align ? 'text-' + header.table.align : 'text-start',
              pagination.descending ? 'desc' : 'asc',
              header.table.sortable !== false && 'sortable',
              header.value === pagination.sortBy && header.table.sortable != false && 'active'
            ]"
            @click="changeSort(header)">

            <span
              class="text--lighten-4"> {{header.text}}
              <v-icon class="v-data-table-header__icon"
                v-if="header.table.sortable !== false && pagination.sortBy === header.value"
                small>mdi-arrow-up
              </v-icon>
            </span>

          </th>
        </tr>
        <tr class="lighten-3" v-if="!noSearch">
          <th
            v-for="header in headers"
            :key="header.value">

            <component v-if='header.table.searchComponent' :is="header.table.searchComponent" :header="header"
              v-model="localFilters[header.value]" @input='() => getData(true)' />

            <div v-else-if="header.table.filter" :style="{ 'max-width': `${ header.table.width || 200}px` }">
              <v-text-field
                class='pt-0 mt-0'
                v-if="header.type === 'text' || !header.type"
                v-model="localFilters[header.value]"
                :placeholder="header.table.filter.placeholder || 'Search'"
                @input='() => getData(true)'
                clearable
                md4
              />

              <v-select
                v-if="header.type === 'list'"
                v-model="localFilters[header.value]"
                :items="list(header.list)"
                :placeholder="header.table.filter.placeholder || 'Select'"
                @input='() => getData(true)'
                clearable
                md4
                class="pt-0 mt-0"
              />
              
              <v-text-field
                class='pt-0 mt-0'
                v-if="header.type === 'autocomplete'"
                v-model="localFilters[header.value]"
                :placeholder="header.table.filter.placeholder || 'Search'"
                @input='() => getData(true)'
                clearable
                md4
              />
              <!-- TODO: 
                <CoreField manual select hide-label :field="header" v-model="localFilters[header.value]" @input='() => getData(true)' />
              -->
              <!-- <core-field
                v-if="header.type === 'search_autocomplete'"
                select
                :field="{
                  value: header.value,
                  text: header.text,
                  id: header.id,
                  filter: header.filter,
                  list: header.list,
                  reference: header.reference,
                  title: header.title,
                  subtitle: header.subtitle,
                  type: 'autocomplete',
                  placeholder: 'Select',
                  full: true,
                }"
                v-model='localFilters[header.value]'
                @input='() => getData(true)' /> -->

              <!-- //issue 316 - modifica date da-a -->
              <!-- issue 257 services -->
              <CoreField v-if="(header.type === 'datetime' || header.type === 'date') && !header.filtertofrom" manual select hide-label :field="header" v-model="localFilters[header.value]" @input='() => getData(true)' />

              <CoreField v-if="(header.type === 'datetime' || header.type === 'date') && typeof(header.filtertofrom) !== 'undefined' && header.filtertofrom === true" manual 
                select hide-label :field="header" v-model="localFilters[header.value + '_$$$_from']" @input='() => getData(true)' 
                :placeholderx="header.table.filter.placeholder || 'Search From'" />

              <CoreField v-if="(header.type === 'datetime' || header.type === 'date') && typeof(header.filtertofrom) !== 'undefined' && header.filtertofrom === true" manual 
                select hide-label :field="header" v-model="localFilters[header.value + '_$$$_to']" @input='() => getData(true)' 
                :placeholderx="header.table.filter.placeholder || 'Search To'"/>
              <!-- issue 257 services -->  
              <!-- //issue 316 - modifica date da-a -->
              
              <v-select
                style="width: 100px;"
                v-if="header.type === 'check'"
                v-model="localFilters[header.value]"
                :items="[{ text: 'True', value: 1 },{ text: 'False', value: 0 }]"
                :placeholder="header.table.filter.placeholder || 'Select'"
                @input="() => getData(true)"
                clearable
                md4
                class="mt-0 pt-0"
              />

            </div>
          </th>
        </tr>
        </thead>
      </template>

      <template
        slot="item"
        slot-scope="{ item }">
        <tr>
          <td
            v-for="header in headers"
            :key="header.value"
            class="text-left">

            <div style='min-width: 90px;' v-if="header.value === 'actions'" class="text-right">
              <v-tooltip
                v-for="(action, id) in actions"
                :key="id"
                top>
                <template
                  slot="activator"
                  slot-scope="{ on }">
                  <a
                    :data-test='action.value'
                    v-show='!disableAction(action, item)'
                    :class="{ 'ml-2': id !== 0 }"
										:href="action.href && action.href(item)"
                    flat
                    @click="evt => doAction(action, item, evt)">
                    <v-icon
                      :color="action.color"
                      v-on="on">{{ action.icon }}</v-icon>
                </a>
                </template>
                <span>{{ action.text }}</span>
              </v-tooltip>
            </div>

            <!-- issue 257 services -->
            <span v-if="header.render && (header.type !== 'date' && header.type !== 'datetime')" v-html='header.render(item)'></span>
            <!-- issue 257 services -->
            <component v-else-if='header.table.component' :is="header.table.component" :item="item"></component>
            <span v-else-if="header.type === 'autocomplete'">
              <!-- {{header.value}} {{header.reference}} {{item}} -->
              <!-- TODO! -->
              {{ getAutocompleteValue(header, item) }}
            </span>
            <span v-else-if="header.type === 'check'">
              <v-icon v-if="item[header.value] && item[header.value] !== '0'" color='green'>mdi-check</v-icon>
              <v-icon v-else color='red'>mdi-close</v-icon>
            </span>
            <!-- issue 257 services -->
            <span v-else-if="header.type === 'date' || header.type === 'datetime'">
              {{ formatDate(item[header.value],header.type) }}
            </span>
            <!-- issue 257 services -->
            <span v-else>{{item[header.value]}}</span>

          </td>

        </tr>
      </template>
    </v-data-table>

    <v-flex
      v-if="modal"
      xs12
      text-right>
      <v-btn
        v-if="modal"
        class="mx-1 font-weight-light"
        color="success"
        small
        @click="$emit('close')"
      >Close</v-btn>
    </v-flex>
  </material-card>
</template>
<script>
// import { normalizeFilters } from '@/utils/filters'
import { upsert, getList, remove, getDetail } from '@/api/base_entity'
import { get, upperFirst as uf } from 'lodash'
import { mapState } from 'vuex'
//issue 257 services
import  moment  from 'moment'
//issue 257 services
/**
 * Generic table component getting data from API,
 * supports search, filter, sort, modal upsert, full page upsert
 */
export default {
  name: 'DataTable',
  props: {
    config: { type: Object, default () {} },
    hideUpsert: { type: [Boolean, Number], default: false },
    hideCreate: { type: [Boolean, Number], default: false },
    hideActions: { type: [Boolean, Number], default: false },
    hideAudit: { type: [Boolean, Number], default: false },
    modal: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false },
    noSearch: { type: Boolean, default: false },
    inlineUpsert: { type: Boolean, default: false },
    hiddenFields: { type: Object, default: () => ({}) },
    filters: { type: Object, default: () => ({}) },
    title: { type: [String, Boolean], default: 'List' },
    upsertTitle: { type: String, default: '' },
    subtitle: { type: String, default: '' },
    apiUpsert: { type: Function, default: upsert },
    apiGetlist: { type: Function, default: getList },
    apiRemove: { type: Function, default: remove },
    apiGetdetail: { type: Function, default: getDetail },
    upsertMaxWidth: { type: String, default: '650px' }
  },
  data () {
    return {
      entityName: this.config.entityName,
      pagination: this.config.pagination,
      loading: true,
      requestId: null,
      item: Object.assign({}, this.hiddenFields),
      items: [],
      get,
      totalItems: 0,
      fields: this.config.fields.map(f => {
        if (f.type !== 'hidden') return f
        if (this.hiddenFields[f.value]) {
          f.value = this.hiddenFields[f.value]
        }
        return f
      }),
      autocompleteItems: {},
      actions: this.config.actions && !this.hideActions && this.config.actions.map(action => {
        if (typeof action === 'string') {
          if (!this.$can(['upsert','audit'].includes(action) ? 'read' : action, this.config.entityName)) return
          return {
            value: action,
            text: action === 'upsert' ? 'Edit' : action === 'remove' ? 'Remove' : 'Audit',
            color: action === 'upsert' ? 'primary' : action === 'remove' ? 'warning' : 'info',
            icon: action === 'upsert' ? 'mdi-pencil' : action === 'remove' ? 'mdi-delete' : 'mdi-timeline-clock-outline'
          }
        }
        if (!this.$can(action.value === 'upsert' ? 'read' : action.value, this.config.entityName)) return
        return {
          ...action,
          label: action.text || uf(action.value)
        }
      }).filter(a => a),
      localFilters:  this.config.filterStorage || {},
      openUpsert: false,
      upsertIsCreate: false,
      validForm: false,
      openAuditTrail: false,
      auditTrailEntityId: null
    }
  },
  computed: {
    ...mapState('app', ['protocol']),
    headers () {
      let headers = this.fields
        .filter(field => field.table)

      if (this.protocol.id !== -1) {
        headers = headers.map(h => {
          if (h.value === 'protocol_id') {
            return { ...h, table: { filter: false }}
          }
          return h
        })
      }

      if (this.actions.length && !this.hideActions) {
        headers.push({ text: '	Actions	', value: 'actions', table: { sortable: false, align: 'right' }})
      }
      return headers
    },
    // visibleFields () {
    //   return this.fields
    //     .filter(f => typeof f.visible === 'function' ? 
    //       f.visible(this.item, this.$store.state) : typeof f.visible === 'undefined' ? true : f.visible)
    // }
  },
  async created () {
    this.getData()
  },
  methods: {
    //issue 257 services
    formatDate(x,type)
    {
      if (type === 'date') //o datetime
        return moment(new Date(x)).format('DD-MMM-YYYY')
      else if (type === 'datetime')
        return moment(new Date(x)).format('DD-MMM-YYYY HH:mm:ss')
      else
        return x
    }
    ,
    //issue 257 services
    disableAction (action, item) {
      if (typeof action.disable !== 'function') {
        return false
      }
      return action.disable(item)
    },
    getAutocompleteValue (header, item) {
      if (header.reference && item[header.reference] && item[header.reference][header.title]) {
        return item[header.reference][header.title]
      }

      if (header.value.indexOf('_') !== -1) {
        const k = header.value.split('_')[0]
        if (item[k] && item[k][header.title]) {
          return item[k][header.title]
        }
      }

      return get(item, header.title)

    },
    list (headerList) {
      if (typeof headerList === 'function') {
        return headerList(null, this.$store.state)
      }
      return headerList
    },    
    upsertSaved (item) {
      this.getData()
      this.$emit('saved', item)
    },
    getData (resetPagination = false) {
      if (resetPagination === true) {
        this.pagination.page = 1
      }
      this.loading = true

     // ci sono i filtri globali specificati dentro la props `filters` per filtrare
      // il subset da mostrare (ad esempio le drugs di un ordine con id: X)
      // e i filtri locali del cerca che se c'e' un metodo filter specificato
      // nel field lo eseguo (che sono i localFilters)
      
      // const filters = normalizeFilters(Object.assign(this.localFilters, this.filters), this.fields)
      const localFilters = this.fields.filter(f => this.localFilters[f.value])
      let filters = {}
      
      //issue 316 - modifica date da-a
      this.fields.forEach((f) => 
        { 
          //issue 380 REDO (aggiunta || f.type === 'date')
          if (f.type === 'datetime' || f.type === 'date')
          {
            if (typeof(f.filtertofrom) !== 'undefined' && f.filtertofrom)
            {
              if (this.localFilters[f.value + '_$$$_from'])
              {
                filters[f.value + '_$$$_from'] = this.localFilters[f.value + '_$$$_from']
              }
              if (this.localFilters[f.value + '_$$$_to'])
              {
                filters[f.value + '_$$$_to'] = this.localFilters[f.value + '_$$$_to']
              }
            }
          }
          //issue 380 REDO
        }
      )
      //issue 316 - modifica date da-a
      
      localFilters.forEach(f => {
        if (typeof f.filter === 'function') {
          filters[f.value] = f.filter(this.localFilters, this.localFilters[f.value])
        } else if (f.type === 'autocomplete') {
          filters[(f.reference || f.value.split('_')[0]) + '.' + f.title] = '%' + this.localFilters[f.value] + '%'
        } else {
          filters[f.value] = '%' + this.localFilters[f.value] + '%'
        }
      })

      filters = Object.assign(filters, this.filters)
      // la paginazione si chiama itemsPerPage e non piu' rowsPerPage

      const requestId = Date.now()
      this.requestId = requestId
      this.apiGetlist(this.entityName, filters, {...this.pagination, rowsPerPage: this.pagination.itemsPerPage}).then(data => {
        if (this.requestId !== requestId) {
          return
        }
        this.items = data.data
        this.$emit('loaded', this.items)
        this.totalItems = data.tot
        this.loading = false
      })
    },
    changeSort (header) {
      if (header.table.sortable === false) return
      this.pagination.page = 1
      if (this.pagination.sortBy === header.value) {
        if (this.pagination.descending === true) {
          this.pagination.sortBy = undefined
        } else {
          this.pagination.descending = !this.pagination.descending
        }
      } else {
        this.pagination.sortBy = header.value
        this.pagination.descending = false
      }
      this.getData()
    },
    save () {
      this.apiUpsert(this.entityName, this.item)
        .then(data => {
          this.item = Object.assign({}, this.hiddenFields)
          this.$refs.form.reset()
          this.$emit('saved', data)
          this.getData()
          this.$root.$emit('openSnackbar', {
            message: (this.config.title || this.title || uf(this.entityName)) + ' updated correctly',
            color: 'success'
          })
        })
        .catch(e => {
          this.$root.$emit('openSnackbar', {
            message: 'An Error occurred during the ' + (this.config.title || this.title || uf(this.entityName)) + ' update. ' +
              (e && e.response ? (e.response.data.error || e.response.data.message || 'Error') : 'Error'),
            color: 'error'
          })
        })
    },
    // upsert or remove
    doAction (action, item, evt = null) {
      if (evt) { evt.stopPropagation() }
      switch (action.value) {
        case 'upsert':
          this.upsertAction(item)
          this.$nextTick(() => {
            // TOFIX
            this.$root.$emit('itemUpdated')
          })
          break
          case 'remove':
            this.removeAction(item)
            break
          case 'audit':
            if (this.hideAudit) {
              this.$emit(action.value, item)
              return
            }
            if (this.config.id && this.config.id.length>0) {
              item.id = this.config.id.reduce( (ret, id) =>  ret ? ret += `_${item[id]}` : item[id],'')
            }
            this.auditTrailEntityId = item.id
            this.openAuditTrail = true
            break
        default:
          this.$emit(action.value, item)
      }
    },
    async removeAction (item) {
      const ret = await this.$root.$confirm.open('Confirm removal', 'Are you sure to remove this item?', { color: 'red' })
      if (ret) {
        if (this.config.id && this.config.id.length>0) {
          item.id = this.config.id.reduce( (ret, id) =>  ret ? ret += `_${item[id]}` : item[id],'')
        }
        this.apiRemove(this.entityName, item)
          .then( () => {
            this.$emit('removed', item)
            this.$root.$emit('openSnackbar', {
              message: (this.config.title || this.title || uf(this.entityName)) + ' removed',
              color: 'success'
            })
            this.getData()
          })
          .catch(e => {
            this.$root.$emit('openSnackbar', {
              message: 'An error occurred during ' + (this.config.title || this.title || uf(this.entityName)) + ' removal: ' +
                (e && e.response ? (e.response.data.error || e.response.data.message || 'Error') : 'Error'),
              color: 'error'
            })
          })
      }
    },
    upsertAction (item = false) {
      if (!this.config.upsert || this.config.upsert === 'modal') {
        this.item = item && Object.assign({}, item) || { ...this.hiddenFields }
        this.openUpsert = true
        this.upsertIsCreate = !item
      } else {
        if (item) {
          this.$router.push(`/${this.entityName}/${item.id}`)
        } else {
          this.$router.push(`/${this.entityName}/new`)
        }
      }
    }
  }
}
</script>

<style lang="scss">
#dataTable {
  .v-datatable__actions {
    color: black;
    .v-btn__content {
      color: black;
    }
    .v-btn {
      background-color: rgb(241, 241, 241);
    }
  }

  tr.lighten-3 th {
    padding: 0px 5px 0px 5px;
  }
  tr:nth-of-type(odd) {
    background-color: rgba(0, 0, 0, .02);
  }
}
</style>
